module.exports = __webpack_public_path__ + "static/img/17.aabb5c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/17.jpg
// module id = mslt
// module chunks = 1